import { render, staticRenderFns } from "./TableChamCong.vue?vue&type=template&id=d7641eb2&scoped=true"
import script from "./TableChamCong.vue?vue&type=script&lang=js"
export * from "./TableChamCong.vue?vue&type=script&lang=js"
import style0 from "./TableChamCong.vue?vue&type=style&index=0&id=d7641eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7641eb2",
  null
  
)

export default component.exports